import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CamaraRulesService } from '../camara-rules.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CamaraRule } from '@helpers/types/models';
import { CircleWarningComponent } from '@helpers/components/circle-warning/circle-warning.component';
import { AlarisDialogComponent } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-camara-rule-delete-dialog',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss'],
	imports: [
		CircleWarningComponent,
		AlarisDialogComponent,
		TranslateModule
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CamaraRuleDeleteDialogComponent {
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(DIALOG_DATA) public data: { rule: CamaraRule },
		public readonly service: CamaraRulesService,
		private dialogRef: DialogRef<boolean>
	) {}

	confirm(): void {
		this.service
			.delete({ id: this.data.rule.id! })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => this.dialogRef.close(true));
	}

	close(): void {
		this.dialogRef.close(false);
	}
}